<script lang="ts">
  // Vertical bars with a label under each — inline SVG, no chart library.
  // Ported from the edge server's Stats.svelte bar-wrap block, redrawn as
  // SVG rather than CSS-height divs so it scales with the card instead of
  // needing a fixed pixel height.
  //
  // Used for rankings (top-5 by hours) and small categorical series
  // (weekday pattern, leave by month), where a labelled column per item is
  // more readable than a line.
  import { accentClasses } from './chartAccent';

  const {
    labels,
    values,
    accent = 'teal',
    ariaLabel,
    unit = ''
  }: {
    labels: string[];
    values: number[];
    accent?: string;
    ariaLabel: string;
    unit?: string;
  } = $props();

  const c = $derived(accentClasses(accent));
  const max = $derived(Math.max(...values, 1));
  const W = 100;
  const H = 42;
  const BASE = 38;
  // Floor the slot count so a one- or two-item ranking draws narrow bars
  // anchored left rather than a full-width slab, which reads as a fill
  // rather than a measurement.
  const slot = $derived(W / Math.max(values.length, 4));
</script>

{#if values.length > 0}
  <div>
    <svg
      viewBox="0 0 {W} {H}"
      preserveAspectRatio="none"
      class="h-24 w-full"
      role="img"
      aria-label="{ariaLabel}: {labels.map((l, i) => `${l} ${values[i]}${unit}`).join(', ')}"
    >
      <line x1="0" y1={BASE} x2={W} y2={BASE} class="stroke-toyama-cloudy-gray" stroke-width="0.5" />
      {#each values as value, i (i)}
        <!-- A real zero gets no bar at all rather than a 1px stub: a stub
             reads as "a little bit", and zero is not a little bit. -->
        {@const h = value > 0 ? Math.max(1, (value / max) * (BASE - 2)) : 0}
        <rect x={i * slot + slot * 0.18} y={BASE - h} width={slot * 0.64} height={h} class={c.fill} rx="0.6">
          <title>{labels[i] ?? ''}: {value}{unit}</title>
        </rect>
      {/each}
    </svg>
    <!-- Captions track the bars, including the same minimum slot count, so
         a short series' labels stay under their own columns. -->
    <div class="mt-1 flex text-[10.5px] text-dark-gray">
      {#each labels as label, i (i)}
        <span class="min-w-0 truncate px-0.5 text-center" style="width:{slot}%" title={label}>{label}</span>
      {/each}
    </div>
  </div>
{/if}
